import { render, staticRenderFns } from "./WarehouseDesktopInventory.vue?vue&type=template&id=20cbbeb2"
import script from "./WarehouseDesktopInventory.vue?vue&type=script&lang=js"
export * from "./WarehouseDesktopInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports